export default {
  getChartColors() {
    return [
      '#7B2DA4',
      '#0059AF',
      '#003263',
      '#006C72',
      '#00B4BF',
      '#4E1D68',
      '#E99E0D',
      '#D171C2',
      '#B75061',
    ];
  },
  getAverageData(data) {
    let total = 0;

    data.forEach((item) => {
      total += item;
    });

    return total / data.length;
  },
};
